import { __extends } from "tslib";
import * as React from 'react';
import withPlaybackContext from '../../common/withPlaybackContext';
var Playlist = /** @class */ (function (_super) {
    __extends(Playlist, _super);
    function Playlist() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleTrackPlaying = function (trackPosition) { return function () {
            var _a = _this.props.context, isPlaying = _a.isPlaying, getTrackIndex = _a.getTrackIndex;
            var currentTrackIndex = getTrackIndex();
            if (trackPosition === currentTrackIndex && isPlaying) {
                _this.props.context.pause();
            }
            else {
                _this.props.context.setTrackIndex(trackPosition);
            }
        }; };
        return _this;
    }
    Playlist.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, context = _a.context;
        var playlist = context.playlist, getTrackIndex = context.getTrackIndex;
        var isPlaying = context.isPlaying, isPlayingInterrupted = context.isPlayingInterrupted;
        return (React.createElement("div", { "data-hook": this.props.dataHook }, playlist.map(function (track, index) {
            return children &&
                children({
                    track: track,
                    index: index,
                    handleTrackPlaying: _this.handleTrackPlaying(index),
                    isFocused: index === getTrackIndex(),
                    isActive: index === getTrackIndex() &&
                        (isPlaying || isPlayingInterrupted),
                });
        })));
    };
    Playlist.displayName = 'Playlist';
    Playlist.defaultProps = { dataHook: '' };
    return Playlist;
}(React.Component));
export default withPlaybackContext(Playlist);
//# sourceMappingURL=Playlist.js.map